import React from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  return <section id="precio-lanzamiento" className="bg-familia-bg border-t border-familia-cyan/30 py-7 md:py-11 px-4 md:px-6" data-id="element-264">
      <div className="max-w-3xl mx-auto text-center w-[92%] md:w-full" data-id="element-265">
        <h2 className="text-familia-red font-bold text-sm sm:text-lg md:text-xl mb-5 md:mb-8 animate-blink uppercase tracking-widest text-center" data-id="element-266">
          ⏰ WHY THIS PRICE WON'T LAST
        </h2>
        <Countdown className="mb-5 md:mb-8 scale-90" data-id="element-267" />
        <p className="text-familia-gray text-xs sm:text-sm md:text-base mb-5 md:mb-8 text-center max-w-2xl mx-auto" data-id="element-268">
          We launched Vitality 360™ at $25 to make it accessible to as many
          families as possible during our initial release period. Once we reach
          our founding member limit — the price moves to $79. This is how we
          reward the families who choose to act early.
          <br data-id="element-269" />
          <span className="block mt-2 font-semibold" data-id="element-270">
            Launch price availability · Limited time · Complete 2026 System
          </span>
        </p>
        <div className="max-w-sm mx-auto bg-familia-card border border-familia-cyan/25 p-3 md:p-4 rounded-xl" data-id="element-271">
          <div className="flex justify-between items-center mb-3" data-id="element-272">
            <div className="flex items-center gap-2" data-id="element-273">
              <span className="w-1.5 h-1.5 bg-familia-red rounded-full animate-ping" data-id="element-274" />
              <span className="text-[10px] sm:text-xs font-bold" data-id="element-275">
                Launch price availability
              </span>
            </div>
            <span className="text-familia-red font-bold text-[10px] sm:text-xs" data-id="element-276">
              Limited time
            </span>
          </div>
          <div className="w-full bg-white/5 h-2 rounded-full overflow-hidden" data-id="element-277">
            <div className="bg-familia-cyan h-full w-[15%]" data-id="element-278" />
          </div>
        </div>
      </div>
    </section>;
};